import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Formik } from 'formik';

import RadioGroup, { RadioButton } from '@xingternal/malt-radio-group';
import TextArea from '@xingternal/malt-text-area';
import { PrimaryButtonMedium as SubmitButton } from '@xingternal/malt-button';
import { Form, FormFieldset } from '@xingternal/malt-form';
import { IconShapeTick } from '@xingternal/malt-icon';
import { P } from '@xingternal/malt-typography';

import FormMessage from './../../Components/FormMessage/FormMessage';

import api from '../../utils/api';

import messages from './messages';
import styles from './Logout.css';

const options = [
  {
    label: <FormattedMessage {...messages.surveyAnswerNoTrust} />,
    value: 'no-trust',
  },
  {
    label: <FormattedMessage {...messages.surveyAnswerNotMyDevice} />,
    value: 'not-my-device',
  },
  {
    label: <FormattedMessage {...messages.surveyAnswerNeverForget} />,
    value: 'never-forget',
  },
];

const hasCookie = doc => !!/submittedLogoutSurvey=true/.test(doc.cookie);

const FormView = ({
  handleChange,
  handleSubmit,
  setFieldValue,
  errors,
  values: { logoutReason, otherReason },
  intl: { formatMessage },
}) => (
  <Form onSubmit={handleSubmit} className={styles.surveyContainer}>
    <FormFieldset legend={<FormattedMessage {...messages.surveyHeadline} />}>
      <RadioGroup name={'logoutReason'} onChange={handleChange}>
        {options.map(({ label, value }) => (
          <RadioButton
            key={value}
            onChange={handleChange}
            value={value}
            checked={logoutReason === value}
          >
            {label}
          </RadioButton>
        ))}
      </RadioGroup>

      <TextArea
        maxLength={160}
        name={'otherReason'}
        onChange={e => {
          const { value, maxLength } = e.target;

          if (value.length > maxLength) {
            setFieldValue('otherReason', value.substring(0, maxLength));
          } else {
            handleChange(e);
          }
        }}
        value={otherReason}
        placeholder={formatMessage(messages.surveyTextLabel)}
      />

      <FormMessage error={errors.required} />

      <SubmitButton type={'submit'} style={{ width: `100%` }}>
        <FormattedMessage {...messages.surveySubmit} />
      </SubmitButton>
    </FormFieldset>
  </Form>
);

const SuccessMessage = () => (
  <div className={styles.successMessage}>
    <IconShapeTick size={20} style={{ marginRight: `4px` }} />
    <P level={1} noMargin>
      <FormattedMessage {...messages.surveySuccess} />
    </P>
  </div>
);

const SurveyForm = () => {
  const [showSuccess, setShowSuccess] = useState(false);

  if (showSuccess) return <SuccessMessage />;
  if (!global.document) return null;

  if (hasCookie(global.document)) return null;

  return (
    <Formik
      initialValues={{ logoutReason: null, otherReason: '' }}
      component={injectIntl(FormView)}
      validateOnChange={false}
      validateOnBlur={false}
      validate={({ logoutReason, otherReason }) => {
        const errors = {};

        if (!logoutReason && otherReason === '') {
          errors.required = (
            <FormattedMessage {...messages.surveyErrorRequired} />
          );
        }

        return errors;
      }}
      onSubmit={({ logoutReason, otherReason }) => {
        api
          .post('/surveys', {
            logoutReason,
            otherReason,
          })
          .then(({ success }) => {
            if (success) {
              global.document.cookie = 'submittedLogoutSurvey=true';
              setShowSuccess(true);
              window.scrollTo(0, 0);
            }
          })
          .catch(err => {
            console.error('Error while submitting logout survey: ', err);
          });
      }}
    />
  );
};

export default SurveyForm;
